export const MAX_INDUSTRIES_SELECTED = 3;

export interface IndustryTagDto {
  id: number;
  name: string;
  published: boolean;
  active: boolean;
  type: string;
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/IndustryTagDto.ts